<template>
  <div>
    <div
      class="rounded overflow-hidden flex flex-row bg-white shadow border justify-between"
    >
      <AppIcon
        v-tooltip.up="{
          content: compactMode ? 'Normale modus' : 'Compacte modus',
          placement: compactMode ? 'right' : 'top'
        }"
        icon="fa-regular fa-arrows-left-right-to-line"
        class="control"
        @click="toggleCompactMode"
      />
      <template v-if="!compactMode">
        <AppIcon
          v-tooltip.up="{
            content: 'Inklappen',
            disabled: compactMode
          }"
          class="control"
          icon="fa-regular fa-arrows-to-line"
          @click="collapseAll"
        />
        <AppIcon
          v-tooltip.up="{
            content: 'Uitklappen',
            disabled: compactMode
          }"
          class="control"
          icon="fa-regular fa-arrows-from-line"
          @click="expandAll"
        />
        <AppIcon
          v-tooltip.up="{
            content: 'Pagina verversen',
            disabled: compactMode
          }"
          class="ml-auto control"
          icon="fa-regular fa-arrows-rotate"
          @click="refreshApp"
        />
      </template>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useAppSidebarStore } from "~/stores/AppSidebar";

const { f1, f5 } = useMagicKeys();
const { expandAll, collapseAll, toggleCompactMode } =
  useAppSidebarStore();

whenever(f1, () => {
  toggleCompactMode();
});

whenever(f5, () => {
  refreshApp();
});

function refreshApp() {
  window.location.reload();
}

const { compactMode } = storeToRefs(useAppSidebarStore());
</script>

<style scoped>
.control {
  @apply p-2.5 grow cursor-pointer hover:text-primary;
}
</style>
